import {
  StyledIcon,
  StyledValidationInstruction,
  StyledValidationItem,
  StyledValidationItemsWrapper,
  StyledValidationText,
  StyledValidationError,
  StyledValidationWrapper,
} from './PasswordValidation.style'

export const PasswordValidation = ({ value, ...rest }) => {
  return (
    <StyledValidationWrapper {...rest}>
      <ErrorItem
        label="La password contiene più di due caratteri consecutivi uguali"
        isError={/(.)\1{2,}/.test(value)}
      />
      <StyledValidationInstruction>
        Per la tua sicurezza, la tua password dovrà:
      </StyledValidationInstruction>
      <StyledValidationItemsWrapper>
        <ValidationItem
          label="Avere almeno 11 caratteri"
          isValid={value.length >= 11}
        />
        <ValidationItem
          label="Contenere almeno una lettera maiuscola e una minuscola"
          isValid={/[A-Z]/.test(value) && /[a-z]/.test(value)}
        />
        <ValidationItem
          label="Contenere almeno un numero"
          isValid={/[\d]/.test(value)}
        />
        <ValidationItem
          label="Contenere almeno un carattere speciale"
          // eslint-disable-next-line no-useless-escape
          isValid={/[~!@#$%^&*()\-_=+\[\]\{\}\|\;\:\,\.\<\/?\\\"\'\`>]/.test(
            value
          )}
        />
      </StyledValidationItemsWrapper>
    </StyledValidationWrapper>
  )
}

const ErrorItem = ({ label, isError }) => {
  return (
    isError && (
      <StyledValidationItem>
        <StyledValidationError>{label}</StyledValidationError>
      </StyledValidationItem>
    )
  )
}

// const AlertItem = ({ label, toAlert }) => {
//   return toAlert && (
//     <StyledValidationItem>
//       <Icon
//         Icon={AlertIcon}
//         width="16px"
//       />
//       <StyledValidationText isValid={true}>{label}</StyledValidationText>
//     </StyledValidationItem>
//   );
// };

const ValidationItem = ({ label, isValid }) => {
  return (
    <StyledValidationItem>
      <Icon
        Icon={CheckMarkIcon}
        width="16px"
        stroke={isValid ? '#0187C2' : '#BCBCBC'}
      />
      <StyledValidationText isValid={isValid}>{label}</StyledValidationText>
    </StyledValidationItem>
  )
}

// const AlertIcon = () => {
//   return (
//     <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
//       <path d="M15.0353 10.8334L9.94193 1.95609C9.08326 0.459421 6.91593 0.459421 6.05727 1.95609L0.964598 10.8334C0.112598 12.3188 1.18926 14.1668 2.9066 14.1668H13.0933C14.8106 14.1668 15.8873 12.3188 15.0353 10.8334Z" stroke="#FFA403" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
//       <path d="M8 8.83344V4.83344" stroke="#FFA403" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
//       <path d="M8 11.5001V11.5068" stroke="#FFA403" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
//     </svg>
//   );
// };

const CheckMarkIcon = () => {
  return (
    <svg viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.66663 10.3255L6.66663 12.9922L13.3333 4.99219"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const Icon = ({
  width,
  tabletWidth = width,
  desktopWidth = tabletWidth,
  largeWidth = desktopWidth,
  stroke,
  fill = 'none',
  hoverStroke,
  hoverFill = fill,
  Icon,
  onClick,
}) => {
  return (
    <StyledIcon
      width={width}
      tabletWidth={tabletWidth}
      desktopWidth={desktopWidth}
      largeWidth={largeWidth}
      stroke={stroke}
      fill={fill}
      hoverStroke={hoverStroke}
      hoverFill={hoverFill}
      onClick={onClick}
    >
      <Icon />
    </StyledIcon>
  )
}
